module.exports = __webpack_public_path__ + "static/media/other-room.b8d11df8.jpg";